import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";

class LiterarteTip extends Component {
  _getTitle(type) {
    switch (type) {
      case 1:
        return "Artigo de Opinião";
      case 2:
        return "Biografia";
      case 3:
        return "Campanha de Conscientização";
      case 4:
        return "Carta de Solicitação";
      case 5:
        return "Crônica";
      case 6:
        return "E-mail";
      case 7:
        return "Narrativa";
      case 8:
        return "Poesia";
      case 9:
        return "Texto Institucional";
    }
  }

  _getBody(type) {
    switch (type) {
      case 1:
        return (
          <ul>
            <li>O objetivo do texto é defender uma opinião.</li>
            <li>
              Você precisa tentar convencer o leitor sobre o seu ponto de vista
              ou levá-lo à dúvida.
            </li>
            <li>
              Prepare um roteiro dos parágrafos que pretende escrever, a fim de
              nortear o seu texto.
            </li>
            <li>
              Apresentar o texto em parágrafos auxilia na argumentação e&nbsp;
              facilita o leitor a acompanhar seu raciocínio. Dessa forma, você
              terá sempre um ponto de partida e uma sequência de informações
              sobre a opinião que defende.
            </li>
            <li>
              Para expressar sua opinião, você pode usar expressões como:
              <ul>
                <li>Na minha opinião ...</li>
                <li>Acredito que....</li>
                <li>Discordo de....</li>
                <li>Concordo com....</li>
                <li>Penso que....</li>
                <li>Entendo que ...</li>
              </ul>
            </li>
          </ul>
        );
      case 2:
        return (
          <ul>
            <li>
              Lembre-se que esse tipo de texto visa informar ao leitor sobre a
              vida de uma determinada pessoa ou personagem, portanto é
              necessário apresentar os acontecimentos vivenciados pelo
              biografado em ordem cronológica, desde o nascimento.
            </li>
            <li>
              Os verbos podem estar no pretérito perfeito ou no presente do
              indicativo.
            </li>
            <li>
              A estrutura básica de uma biografia geralmente inclui uma
              apresentação inicial do protagonista (introdução), a descrição dos
              principais fatos que compõem a história (desenvolvimento) e uma
              parte final de caráter subjetivo (conclusão).
            </li>
          </ul>
        );
      case 3:
        return (
          <>
            <p>
              Você deve ficar atento à produção dos elementos básicos do gênero:
              imagem; chamada, produção de um texto explicativo, elementos que
              conferem credibilidade ao texto.
            </p>
            <p>
              A apresentação e diagramação da Campanha fazem toda a diferença.
              Por isso, dê atenção aos elementos abaixo:
            </p>
            <p>
              Cor – Utilize cores para os textos que contrastem com a cor do
              fundo. Evitem por exemplo: texto amarelo sobre fundo branco ou
              texto roxo sobre fundo preto, para não prejudicar a visibilidade
              do conteúdo.
            </p>
            <p>
              Texto – Curto,&nbsp; direto e original. Reduza ao essencial o que
              você quer transmitir focando no seu público alvo.
            </p>
            <p>
              Imagem – aliada ao texto, a imagem deve transmitir a mensagem,
              chamar a atenção. É possível usar fotografias, desenhos,
              aplicações, colagens, etc.
            </p>
            <p>
              Letras – Crie letras legíveis e faça uma distribuição organizada
              entre textos e imagens.
            </p>
          </>
        );
      case 4:
        return (
          <ul>
            <li>
              A intenção do discurso de uma carta de solicitação é retratar uma
              reclamação e/ou solicitação por parte do emissor.
            </li>
            <li>
              Como o objetivo da carta é persuadir o interlocutor, elabore bons
              argumentos, se possível com base em dados concretos e reais.
            </li>
            <li>
              Tente convencer o destinatário a atender sua solicitação ou a
              tomar providências sobre a reclamação.
            </li>
            <li>
              A carta de solicitação deve ser breve, bem estruturada e com
              linguagem clara.
            </li>
          </ul>
        );
      case 5:
        return (
          <ul>
            <li>
              Desenvolva um tema da atualidade com uma linguagem simples,
              informal.
            </li>
            <li>
              O texto pode ser desenvolvido de diferentes formas (narrativo,
              argumentativo, poético, irônico, formal ou coloquial) dependendo
              do tema escolhido.
            </li>
            <li>
              Se a escolha for pela forma narrativa, apresente os personagens e
              suas ações, utilizando discurso direto ou indireto.
            </li>
            <li>Você pode explorar o humor ou a ironia no texto.</li>
            <li>
              Leia e releia para avaliar se a estrutura está correta, se o texto
              é curto, se o foco narrativo está adequado ao tema e se sua visão
              pessoal ficou bem expressa sobre o tema escolhido.
            </li>
            <li>
              Reescreva o texto se achar necessário fazendo as devidas
              alterações e adequações.
            </li>
          </ul>
        );
      case 6:
        return (
          <ul>
            <li>
              Evite digitar a mensagem em caixa alta – isso indica que você está
              gritando.
            </li>
            <li>Sempre preencha o campo assunto.</li>
            <li>
              Você pode usar os smiles para demonstrar para expressar seus
              sentimentos.
            </li>
            <li>Inicie o texto com um nome ou com um cumprimento.</li>
            <li>Ao finalizá-lo, use um termo breve de despedida.</li>
            <li>É possível enviar um arquivo anexado ao seu e-mail.</li>
            <li>
              Seja breve! O texto deve ser curto e direto. Se for para alguém de
              sua proximidade, você pode usar uma linguagem econômica com
              abreviações, tais como: “vc”, “pra”, “bj”.
            </li>
          </ul>
        );
      case 7:
        return (
          <>
            <p>Numa narrativa podemos encontrar vários elementos:</p>
            <ul>
              <li>Personagens – pessoas que participam da história;</li>
              <li>
                Ambiente ou cenário – lugar onde os personagens vivem a história
                narrada;
              </li>
              <li>Tempo- descrição do momento em que os fatos aconteceram;</li>
              <li>
                Fato principal – os acontecimentos principais da narração;
              </li>
              <li>Narrador – pode ser onisciente ou participar dos fatos.</li>
            </ul>
          </>
        );
      case 8:
        return (
          <ul>
            <li>
              Crie o hábito de ler poesias e descubra que tudo o que é do
              cotidiano pode servir de inspiração.
            </li>
            <li>Você pode utilizar versos rimados ou não.&nbsp;</li>
            <li>
              Poesia não fica pronta de primeira....é preciso fazer rascunhos,
              construir com cuidado, buscar palavras.
            </li>
            <li>
              Não se preocupe com a lógica, você deve buscar o novo e
              descrevê-lo de forma bela, revisar e mudar, é como montar um
              quebra-cabeça.
            </li>
            <li>
              Busque ser original! Encontre o novo dentro de você e brinque com
              as palavras para expressar seus sentimentos.
            </li>
          </ul>
        );
      case 9:
        return (
          <ul>
            <li>
              Para criar um bom texto instrucional é preciso conhecer bem o que
              se deseja descrever, a fim de dar orientações corretas.
            </li>
            <li>
              Use linguagem simples e clara. Sempre que possível, utilize
              imagens para ilustrar as instruções.
            </li>
            <li>
              Utilize verbos no infinitivo ou no imperativo para descrever as
              ações em etapas.
            </li>
          </ul>
        );
    }
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>{this._getTitle(this.props.type)}</CModalTitle>
        </CModalHeader>
        <CModalBody>{this._getBody(this.props.type)}</CModalBody>
      </CModal>
    );
  }
}

export default LiterarteTip;
